import { gtm_shop_item_ecommerce_event } from '.'

const gtm_view_item = () => {
  gtm_shop_item_ecommerce_event('view_item')
}

export default gtm_view_item
